import { render } from "./find-salon-stats.vue?vue&type=template&id=14a99b45"
import script from "./find-salon-stats.vue?vue&type=script&lang=js"
export * from "./find-salon-stats.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nathan/Dev/justcuts-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__